module.exports = __webpack_public_path__ + "static/img/70-V1.2badc49.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/70 184/70-V1.gif
// module id = v+Gm
// module chunks = 7